import { formatAlertsDate, formatNumberWithPostfix } from '@Utils/String';

/**
 * Builds the `options` array consumed by the Leyden `SingleSelect` in `ResultsFrom`.
 *
 * Leyden option labels must be plain strings — it lowercases them for its search filter — so the
 * run date and its hit count are formatted into a single label rather than rendered as markup.
 * The value is the `runId`, which is what `selectResultOfAlert` and `fetchResultsInfo` expect.
 */
export function createAvailableResultsOptions(results) {
  if (!results) {
    return [];
  }

  return results
    .map((result) => {
      const runId = result.get('runId');
      const hits = result.get('hits');
      const resultDate = formatAlertsDate(result.get('resultDate'));

      return {
        value: runId,
        label: hits ? `${resultDate} - ${formatNumberWithPostfix(hits)} hits` : resultDate,
      };
    })
    .toArray();
}

export default createAvailableResultsOptions;
